import { useQuery } from '@tanstack/react-query';
import { getFeedbackList } from '../api';
import type { FeedbackFilters } from '../types';

export const FEEDBACK_QUERY_KEY = 'feedback';

interface UseFeedbackOptions {
  filters?: FeedbackFilters;
  enabled?: boolean;
}

export function useFeedback({
  filters, enabled = true 
}: UseFeedbackOptions = {}) {
  return useQuery({
    queryKey: [FEEDBACK_QUERY_KEY, filters],
    queryFn: () => getFeedbackList(filters),
    enabled,
    staleTime: 30_000,
    gcTime: 5 * 60 * 1000,
  });
}
